import { render, staticRenderFns } from "./DataGridIdColumn.vue?vue&type=template&id=135b4367"
import script from "./DataGridIdColumn.vue?vue&type=script&lang=js"
export * from "./DataGridIdColumn.vue?vue&type=script&lang=js"
import style0 from "./DataGridIdColumn.vue?vue&type=style&index=0&id=135b4367&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports